/**
 * Share helper — Web Share API with clipboard fallback.
 * Message mirrors iOS ProfileScreen.tsx handleShareStats exactly, and captures
 * the same profile_share_stats_clicked / profile_share_stats_successful events.
 */
import type { PostHog } from "posthog-js";

export async function shareProfileStats(
  authID: string | undefined,
  posthog?: PostHog
): Promise<void> {
  if (!authID) {
    alert("Something went wrong! Please restart the app and try again.");
    return;
  }

  posthog?.capture("profile_share_stats_clicked", { auth_id: authID });

  const message = `Check out my Spanish learning progress on Parrot! 🦜 https://stats.parrotapp.com/u/${authID}`;

  if (navigator.share) {
    try {
      await navigator.share({ text: message });
      posthog?.capture("profile_share_stats_successful", {
        auth_id: authID,
        method: "web_share",
      });
      return;
    } catch {
      // user cancelled or share failed — fall through to clipboard
    }
  }

  try {
    await navigator.clipboard.writeText(message);
    posthog?.capture("profile_share_stats_successful", {
      auth_id: authID,
      method: "clipboard",
    });
    alert("Link copied to clipboard!");
  } catch {
    alert(message);
  }
}
